import { createSlice } from '@reduxjs/toolkit'

/**
 * State of the menu system in order to isolate UI changes comming from backend notifications.
 */
export const menu = createSlice({
    name: 'menu',
    initialState: {
        moduleName: '',
        currentMenu: '',
        pageIndex: 0,
        pageName: '',
        splitWindowEnabled: false,
        useSplitWindow: false,  // deprecated
        splitMode: false, // true/false
        leftCard: null,  // name of leftCard
        rightCard: null, // name of rightCard
    },
    reducers: {
        setModuleName: (state, action) => {
            state.moduleName = action.payload;
        },
        setCurrentMenu: (state, action) => {
            state.currentMenu = action.payload;
            // console.log('Setting currentMenu = ' + action.payload + ', pageIndex = ' + state.pageIndex);
        },
        setPageIndex: (state, action) => {
            state.pageIndex = action.payload;
            // onsole.log('Setting pageIndex = ' + action.payload + ', currentMenu = ' + state.currentMenu);
        },
        setPageName: (state, action) => {
            state.pageName = action.payload
        },
        setSplitWindow: (state, action) => {
            state.splitWindowEnabled = action.payload.enabled;
            if ( action.payload.leftCard ) {
                state.leftCard = action.payload.leftCard;
            }
            if ( action.payload.rightCard) {
                state.rightCard = action.payload.rightCard;
            }
            if ( typeof action.payload.splitMode === 'boolean' ) {
                state.splitMode = action.payload.splitMode;
            }
        },
        setSplitMode: (state,action) => {
            state.splitMode = action.payload;
        },
        setLeftCard: (state,action) => {
            state.leftCard = action.payload;
        },
        setRightCard: (state,action) => {
            state.rightCard = action.payload;
        },
    },
});

export const workfront = createSlice({
    name: 'workfront',
    initialState: {
        listValue: true,
        showList: true,
        instanceValue: false,
        showInstance: false,
        instanceNode: null,
        expandedKeys: {},
        windowMenuEnabled: false,
        splitWindowEnabled: false,
        leftSplitPageIndex: 0,
        leftSplitPageName: '',
        rightSplitPageIndex: 0,
        rightSplitPageName: '',
    },
    reducers: {
        setWorkList: (state, action) => {
            state.showList = action.payload.showList;
            state.listValue = action.payload.listValue;
            // console.log('Setting currentMenu = ' + action.payload + ', pageIndex = ' + state.pageIndex);
        },
        setWorkInstance: (state, action) => {
            state.showInstance = action.payload.showInstance;
            state.instanceValue = action.payload.instanceValue;
            
            // onsole.log('Setting pageIndex = ' + action.payload + ', currentMenu = ' + state.currentMenu);
        },
        setWorkNode: (state,action) => {
            state.instanceNode = action.payload
        },
        setExpandedKeys: (state,action) => {
            state.expandedKeys = action.payload
        },
        setWindowMenu: (state, action) => {
            state.windowMenuEnabled = action.payload.enabled;
        },
        setSplitWindow: (state,action) => {
            state.splitWindowEnabled = action.payload.enabled;
        },
        setSplitWindowPage: (state,action) => {
            if (action.payload.window === 'LEFT') {
                state.leftSplitPageIndex = action.payload.pageIndex;
                state.leftSplitPageName = action.payload.pageName;
            } else if ( action.payload.window === 'RIGHT' ) {
                state.rightSplitPageIndex = action.payload.pageIndex;
                state.rightSplitPageName = action.payload.pageName;
            }
        }

    },
});

// same as workfront but for Runtime management
export const runtime = createSlice({
    name: 'runtime',
    initialState: {
        listValue: true,
        showList: true,
        instanceValue: false,
        showInstance: false,
        instanceNode: null,
        expandedKeys: {},
    },
    reducers: {
        setRuntimeList: (state, action) => {
            state.showList = action.payload.showList;
            state.listValue = action.payload.listValue;
            // console.log('Setting currentMenu = ' + action.payload + ', pageIndex = ' + state.pageIndex);
        },
        setRuntimeInstance: (state, action) => {
            state.showInstance = action.payload.showInstance;
            state.instanceValue = action.payload.instanceValue;
            
            // onsole.log('Setting pageIndex = ' + action.payload + ', currentMenu = ' + state.currentMenu);
        },
        setRuntimeNode: (state,action) => {
            state.instanceNode = action.payload
        },
        setRuntimeExpandedKeys: (state,action) => {
            state.expandedKeys = action.payload
        },
    },
});

// to control popup of some step actions
export const stepaction = createSlice({
    name: 'stepaction',
    initialState: {
        // after setting up action buttons, automatically open next or previous action
        openNextStep: false,
        // current action that triggered the state change
        openStepAction: null,
        openWorkflowId: -1,
        // current step that triggered the state change
        // openStepId: -1,
    },
    reducers: {
        setOpenNextStep: (state,action) => {
            if ( action.payload.openNextStep !== state.openNextStep ) {
                state.openNextStep = action.payload.openNextStep;
            }
            if ( action.payload.openStepAction !== state.openStepAction ) {
                state.openStepAction = action.payload.openStepAction;
            }
            if ( action.payload.openWorkflowId !== state.openWorkflowId ) {
                state.openWorkflowId = action.payload.openWorkflowId;
            }
            // state.openStepId = action.payload.openStepId;
        },
    },
});

export const { setModuleName, setCurrentMenu, setPageIndex, setPageName, setSplitWindow, setSplitMode, setLeftCard, setRightCard } = menu.actions;
export const { setWorkInstance, setWorkList, setWorkNode, setExpandedKeys } = workfront.actions;
export const { setRuntimeInstance, setRuntimeList, setRuntimeNode, setRuntimeExpandedKeys } = runtime.actions;
export const { setOpenNextStep } = stepaction.actions;